export default __webpack_public_path__ + "static/media/screen8.9e5cae3e.svg";